import axios from "axios";

let actions = {

  async createProfile({ state, commit }) {
    try {
      // put user if he doesn't exist
      let url = "users";
      const headers = {
        "content-type": "application/json",
      };
      let data = JSON.parse(JSON.stringify(state.identity));
      const response = await axios.post(url, data, headers);
      commit("setUserId", response.data);
    } catch (err) {
      console.log(`err`, err);
      console.error(err);
    }
  },

  async updateProfile({ state }) {
    try {
      // put user if he doesn't exist
      let url = "users/" + state.identity.id;
      const headers = {
        "content-type": "application/json",
      };
      let data = JSON.parse(JSON.stringify(state.identity));
      await axios.put(url, data, headers);
    } catch (err) {
      console.log(`err`, err);
      console.error(err);
    }
  },

  // GET profile from BDD
  async getProfile({ state, commit, dispatch }) {
    // console.log("GO TAKE USER !!!!")
    try {
      // search user
      let url = "users?sub=" + state.identity.sub;
      const headers = {
        "content-type": "application/json",
      };
      const response = await axios.get(url, headers);
      // console.log("This is the response :", response)
      if (response.data.length) {
        commit("setUserId", response.data[0]._id);
        commit("setLang", response.data[0].lang);
        commit("setFavorites", response.data[0].favorites);
        commit("setLastConnection");
        await dispatch("updateProfile"); // add last co to DB
      } else {
        commit("setLastConnection");
        dispatch("createProfile");
      }
    } catch (err) {
      console.log(`err`, err);
      console.error(err);
    }
  },
};

export default actions;
